import { useApplicationContext } from '../../../../utils/applicationContext';

export const useCianMortgageUrl = () => {
  const { config } = useApplicationContext();

  return (
    config.get<string>('newbuilding-promos-frontend.cianMortgageUrl') ?? '/ipoteka-main/?banner=newbuilding-promos'
  );
};
